import React from 'react';
import { call } from 'redux-saga/effects';

import * as StatsActions from './actions';
import * as StatsConstants from './constants';
import * as D from './deps';
import StatsReducer from './reducer';
import * as StatsHelpers from './sagas/helpers';
import StatsWatchers from './sagas/watchers';
import * as StatsWorkers from './sagas/workers';
import * as StatsSelectors from './selectors';
import * as StatsUtils from './utils';

export default D.createDomainModule({
  name: StatsConstants.DOMAIN_NAME,
  actions: StatsActions,
  reducer: StatsReducer,
  constants: StatsConstants,
  utils: StatsUtils,
  selectors: StatsSelectors,
  components: {
    StatsTestLogger: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_stats-test-logger" */ './components/StatsTestLogger/StatsTestLogger',
            )
          }
        />
      );
    },
  },
  onLoad(store) {
    // before we leave the site make any queued stats calls
    window.addEventListener('unload', () => {
      store.runSaga(function* () {
        yield call(StatsHelpers.sendBatchedEventsToServer, true);
      });
    });
    this.runSaga(store, StatsWorkers.initializeStats);
  },
  onStart(store) {
    this.registeredHandlers = D.registerHandlers(StatsWatchers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
